"use client"
import React from 'react';
import dynamic from 'next/dynamic';
import { TermsReminderStep } from './steps/terms-reminder-step';
import { PlayResponsiblyStep } from './steps/play-responsibly-step';
import { useLoginConfirmationFlags } from './model/hook';

const LoginConfirmationModal = () => {
  const {
    isClient,
    isPhOnly,
    termsConfirmed,
    playResponsiblyConfirmed,
    confirmTerms,
    confirmPlayResponsibly,
  } = useLoginConfirmationFlags();

  if (!isClient) {
    return null;
  }

  if (!isPhOnly) {
    return null;
  }

  if (termsConfirmed && playResponsiblyConfirmed) {
    return null;
  }

  if (!termsConfirmed) {
    return <TermsReminderStep isOpen onAccept={confirmTerms} />;
  }

  return <PlayResponsiblyStep isOpen onAccept={confirmPlayResponsibly} />;
};

const LoginConfirmationModalDynamic = dynamic(
  () => Promise.resolve(LoginConfirmationModal),
  {
    ssr: false,
    loading: () => null,
  }
);

export { LoginConfirmationModal, LoginConfirmationModalDynamic };
